import { useEffect } from 'react';
import { Button, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useRequest } from 'ahooks';
import { useSelector } from 'react-redux';
import heat from '@/assets/heat.png';
import ScrollTable from '../components/ScrollTable/ScrollTable';
import { getTransformationApplyTop10 } from '@/services/transformationFinancing';
import { getToken } from '@/utils/token';
import './index.less';

export default function Index() {
  const Navigate = useNavigate();
  const { status, userType } = useSelector((state) => state);

  const { data, loading } = useRequest(getTransformationApplyTop10);

  useEffect(() => {
    if (userType === 2) {
      Navigate('/home');
    }
  }, []);
  function handleChange() {
    const token = getToken();
    if (!token) {
      Navigate('/login');
    } else if (status) {
      Navigate('/authentication');
    } else {
      Navigate('/transformationFinancing/application');
    }
  }
  return (
    <div className="transformation-financing">
      <div className="major-financing__banner">
        转型项目融资
      </div>
      <Spin spinning={loading}>
        <div className="scroll-box">
          <div className="content-width scroll-box__grid">
            <div>
              <div className="scroll-box__title-box">
                <img src={heat} width={24} alt="" />
                <div className="scroll-box__title">最新申请动态</div>
              </div>
              <ScrollTable
                data={data}
                columns={['企业名称', '项目名称', '建设地点', '贷款总需求（万元）']}
                dataIndex={['applicantName', 'projectName', 'projectCityArea', 'totalLoanDemand']}
              />
            </div>
            <div className="scroll-box__last">
              <div className="scroll-box__title-box">
                <img src={heat} width={24} alt="" />
                <div className="scroll-box__title">最新授信动态</div>
              </div>
              <ScrollTable
                data={[]}
                columns={['企业名称', '项目名称', '转型路径', '授信金额（万元）']}
                dataIndex={['applicantName', 'projectName', 'projectCityArea', 'totalLoanDemand']}
              />
            </div>
          </div>
        </div>
      </Spin>
      <div className="major-financing__btn">
        <Button type="primary" onClick={() => handleChange()}>立即申请</Button>
      </div>
    </div>
  );
}
